import { Box, Heading, Stack, StackProps } from "@chakra-ui/react";
import Image from "next/image";
import { ReactNode } from "react";

interface ICard extends StackProps {
  title: string;
  price: string;
  descriptions: ReactNode;
  button: ReactNode;
  isIdealniNajemce?: boolean;
}
const Card: React.FC<ICard> = ({
  button,
  descriptions,
  isIdealniNajemce,
  price,
  title,
  ...props
}) => (
  <Stack maxW={{ md: "340px" }} flex={1} spacing={0} justify="end" {...props}>
    <Stack
      borderRadius="6px"
      boxShadow="0rem 0.188rem 1rem rgba(0, 0, 0, 0.24)"
      spacing={0}
    >
      {isIdealniNajemce && (
        <Stack backgroundColor="ud-primary-200" p="6px" align="center">
          <Image
            src="/img/common/logo_in.svg"
            alt="Ideální nájemce"
            width="100"
            height="24"
            style={{ marginBottom: "-14px" }}
          />
        </Stack>
      )}
      <Stack spacing="40px" p="32px">
        <Box
          pb="40px"
          borderBottomColor="ud-grey-300"
          borderBottomWidth="1px"
          borderBottomStyle="solid"
          textAlign="center"
        >
          <Heading as="h2" variant="h3">
            {title}
          </Heading>
          <Heading as="h2" variant="h3" color="ud-primary">
            {price}
          </Heading>
        </Box>
        {descriptions}
        {button}
      </Stack>
    </Stack>
  </Stack>
);

export default Card;
